import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE, Terrassor_RECALCULATE } from "../../../../interface.js"

/* @ngInject */
export class AnimationController {
    /* @ngInject */
    constructor (ApiConst, ApiSimu, ApiExo, $scope) {
      this.ApiConst = ApiConst
      this.ApiSimu = ApiSimu
      this.ApiExo = ApiExo
      this.$scope = $scope
    }

    testerValidation() {
       console.log('testerValidation --------------------------------------------------------------------------------------')
        var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "valide":[]})
        return(retour.retour);
    }

    $onInit() {
      // On a accès au controller du Simulator
console.log('$onInit animation.controller ------------------------------')
console.log('this.parentSimulator : ', this.parentSimulator)

        // BC 31/07
        this.isPlaying = this.testerValidation();
console.log('this.isPlaying', this.isPlaying)
        if (this.isPlaying == true) {

            var retour = this.parentSimulator.lancerSVG(true) // normalement, pas la peine de passer true (à tester)
            if (retour.retour == true) {
                this.parentSimulator.animationIsPlaying = true  // pour affichage du TdB
            }
            else {
                this.parentSimulator.correct() // il y a un pb, on reinitialise (ne doit pas arriver mais en debug on peut sortir avec des données pourries)
                this.parentSimulator.saveNbJoursAtteints(0)
                this.parentSimulator.lancerSVG(true)
                //this.restartButtonsVisibles = false
                this.parentSimulator.setAnalyseContent(null)
                this.parentSimulator.bilanContent = "" // 2018/09/14

            }
        }
        else {
            this.parentSimulator.animationIsPlaying = false  // pour affichage du TdB
            // je ne comprends pas pourquoi je dois faire ça ...
            /*this.isPlaying = true
            this.isPlaying = false  */
        }

        // remplace
        // this.isPlaying = false
    }

    
    // 

    doOnclickPlay() {
      console.log('AnimationController::doOnclickPlay', this)

      this.isPlaying = true

      var retour = this.parentSimulator.lancerSVG(true)
      this.saveAnalyse(retour.analyse)

      if(retour.retour == false) {

          // creer un objet errorMessage        
          var commentaire = retour.objet
          var context = this.setValidationContext(retour)
          var errorMessage = {}
          errorMessage.context = context
          errorMessage.message = commentaire
          errorMessage.type = 'error'

          // envoyer l'erreur pour affichage dans la modal-dialog (via simulatorController)
          this.parentSimulator.dispatchTerrassorMessages(errorMessage)   // et dans le module concerné
          this.showValidationComment(errorMessage)

          this.parentSimulator.animationIsPlaying = false // pour masquage du TdB
        }    
      else {
        // affichage du TdB et changement des consignes
        this.parentSimulator.animationIsPlaying = true  
        this.parentSimulator.dispatchTerrassorMessages()  
      }

      this.parentSimulator.analyseContent = ''
  }



   
/*
*clic sur les etiquettes du SVG CdF
*/
   clickCubature(codes) {
      console.log('AnimationController::clickCubature', codes)    

      //this.parentSimulator.setCurrentDashBoardContext(codeMvt, codeCub)      
    }

/**
* Envoi d'une erreur au Simulateur (message + contexte, etc...)
* Le controlleur enverra ensuite l'eerur dans boite de dialogue dédiée, ou dans un panel adapté
*/
sendErrorMessage(errorMessage) {
  this.parentSimulator.dispatchErrorMessage(errorMessage)
}


/*
* A partir des propriétés du retour de lancer SVG, on définit un objet "context", qui précisera la nature de l'erreur éventuelle
*/
setValidationContext(retour) {
  var context = {"panel":null, "data":null, "subData":null}

  if(retour.isMouvement) {
    context.panel = "MOUVEMENT"
    if(retour.codeMouvement) {
      context.data = retour.codeMouvement
      if(retour.ordreEchelon)
        context.subData = retour.ordreEchelon
    }
  }

 if(retour.isInstallation)  
    context.panel = "INSTALLATION"

  return context

}

/*
*/
   showValidationComment(errorMessage) {
    this.sendErrorMessage(errorMessage)
      // this.messageValidation = errorMessage.message // remplacé par modalebox
    }


/*
*/
saveAnalyse(analyse) {
  this.ApiSimu.saveAnalyse(analyse)
}

calerEnteteEngins() {
    var constanteHauteurEntete = 122;
    var delta = $( "div#conteneurAgendaSVG" ).height()-constanteHauteurEntete;
    var pos = $("#agendaSVG").position().top*(-1)+delta;
    var posMax = $("#agendaSVG").height();
    pos = Math.min(pos, posMax);
    $("#enginSVG").css("top", pos+"px");
}
agrandirReduire(reduire) {
    var myEl1 = angular.element( document.querySelector( '#conteneurAgendaSVG' ) );
    var myEl2 = angular.element( document.querySelector( '#agrandirReduire span' ) );
    if (myEl1.hasClass('grand') || reduire) {
        myEl1.removeClass('grand');
        myEl2.text("Agrandir l'agenda");
    }
    else {
        myEl1.addClass('grand');
        myEl2.text("Réduire l'agenda");
    }
    this.calerEnteteEngins();
}

flipFlap() {
        var myEl1 = angular.element( document.querySelector( '#conteneurAgendaSVG' ) );
        var myEl2 = angular.element( document.querySelector( '#svgContainerCF' ) );
        var myEl3 = angular.element( document.querySelector( '#agrandirReduire' ) );
        var mySpan = angular.element( document.querySelector( '#flipFlapSpan' ) );
        if (myEl1.hasClass('cacher')) {
            this.parentSimulator.lancerAGENDA()
            myEl2.addClass('cacher')
            myEl1.removeClass('cacher');
            myEl3.removeClass('cacher');
            mySpan.text('Planning');
        }
        else {
            myEl1.addClass('cacher')
            myEl3.addClass('cacher')
            myEl2.removeClass('cacher');
            mySpan.text('Engins');
            this.agrandirReduire(1);
        }
    }

    /*afficherTableauDeBord() {

      var T_interface = get_Terrassor_INTERFACE()
      var datas = T_interface.donnerInfosTableauDeBord();
      console.log('AnimationController::afficherTableauDeBord date', datas.chantier.date)

    }*/

}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/animation/animation.controller.js